import { render, staticRenderFns } from "./ClipboardAdapter.vue?vue&type=template&id=2ead38ca&scoped=true&"
import script from "./ClipboardAdapter.vue?vue&type=script&lang=ts&"
export * from "./ClipboardAdapter.vue?vue&type=script&lang=ts&"
import style0 from "./ClipboardAdapter.vue?vue&type=style&index=0&id=2ead38ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ead38ca",
  null
  
)

export default component.exports